import React, { useEffect, useState } from "react";
import Dashboard from "../../../layouts/Dashboard";
import { ReactLoading } from "../../Dashboard/TinManagement/import";
import { Card, Select, DatePicker, message } from "antd";
import moment from "moment";
import exportFromJSON from "export-from-json";
import useAxios from "../../../hooks/useAxios";
import swal from "sweetalert";
import { checkPermission } from "../../../utils/checkPermission";
import useRole from "../../../hooks/useRole";

const { RangePicker } = DatePicker;
const { Option } = Select;

const exportType = "csv";
let fileName = `AUDIT_REPORT${moment(new Date()).format(
  "DD-MM-YYYY_HH:mm"
)}`;

const AuditReport = () => {
  const api = useAxios();
  const [load, setLoad] = useState(false);
  const [defaultDate, setDefaultDate] = useState([]);
  const [disabled, setDisabled] = useState(false);

  const [canViewAuditReport, setCanViewAuditReport] = useState(false);
  const [canDownloadAuditReport, setCanDownloadAuditReport] = useState(false);
  const userRole = useRole();

  const checkPermissions = async () => {
    try {
      const viewAllowed = await checkPermission(
        userRole,
        "audit_report_module",
        "view_audit_report"
      );
      const downloadAllowed = await checkPermission(
        userRole,
        "audit_report_module",
        "download_audit_report"
      );
      setCanViewAuditReport(viewAllowed);
      setCanDownloadAuditReport(downloadAllowed);
    } catch (err) {
      console.error("Error checking audit report permissions:", err);
    }
  };

  useEffect(() => {
    checkPermissions();
  }, [userRole]);

  const handleDate = (value, dateString) => {
    if (value === null) {
      setDefaultDate([]);
    } else {
      let startDate = moment(dateString[0], "YYYY-MM-DD");
      let endDate = moment(dateString[1], "YYYY-MM-DD");

      if (moment(endDate).isAfter(moment(startDate).add(60, "days"))) {
        swal({
          title: "You can not select data more than 60 days",
          icon: "error",
        });
      } else {
        setDefaultDate([startDate, endDate]);
      }
    }
  };

  const loadCSV = async () => {
    try {
      const result = await api.get(
        `/makercheaker/AuditReport?StartDate=${
          defaultDate[0] ? defaultDate[0]?._i : ""
        }&EndDate=${defaultDate[1] ? defaultDate[1]?._i : ""}`,
        {
          tokenType: "user",
        }
      );
      const rawData = result.data.dataList;
      const flattenArray = rawData?.map((ele) => {
        let flatObject = { ...ele };
        function flatten(obj, keyPrefix) {
          Object.keys(obj).forEach((key) => {
            if (typeof obj[key] === "object") {
              Object.assign(flatObject, obj[key]);
              delete flatObject[key];
            }
          });
        }
        flatten(ele, "");
        return flatObject;
      });
      const data = flattenArray;
      return data;
    } catch (err) {
      throw err;
    }
  };

  const downloadCSV = async () => {
    try {
      const flattenArray = (data) => {
        if (!data) return [];
        return data.map((ele) => {
          let flatObject = { ...ele };
          function flatten(obj) {
            Object.keys(obj).forEach((key) => {
              if (typeof obj[key] === "object" && !Array.isArray(obj[key])) {
                Object.assign(flatObject, obj[key]);
                delete flatObject[key];
              } else if (Array.isArray(obj[key])) {
                console.log("inside array key", obj[key]);
                flatObject[key] = obj[key].toString();
              }
            });
          }

          flatten(ele);
          return flatObject;
        });
      };
      setLoad(true);
      const csvData = await loadCSV();
      if(csvData.length === 0){
        return message.error("No data found.",2)
      }
      const data = flattenArray(csvData);
      exportFromJSON({ data, fileName, exportType });
    } catch (err) {
      console.error(err);
      message.error("An Error Occurred", 2);
    } finally {
      setLoad(false);
    }
  };

  const disabledDate = (current) => {
    return current && current > moment().endOf("day");
  };

  useEffect(() => {
    if (defaultDate.length === 2) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [defaultDate]);

  return (
    <Dashboard title="Active And Inactive Candidates">
      {load && (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      )}
      {canViewAuditReport ? (
        <Card>
          <div className="row ">
            <div className="col-md-3 mt-2">
              <label htmlFor="candidate photo">
                Select Date
                <span style={{ color: "red" }}>*</span>
              </label>
              <RangePicker
                format="YYYY-MM-DD"
                style={{ width: "100%" }}
                onChange={handleDate}
                //   onOk={onOk}
                disabledDate={disabledDate}
                placeholder={[
                  moment(new Date()).format("YYYY-MM-DD"),
                  moment(new Date()).format("YYYY-MM-DD"),
                ]}
              />
            </div>
            {canDownloadAuditReport && (
              <div className="col-md-3 align-items-end d-flex">
                <button
                  disabled={disabled}
                  className={`btn ${
                    disabled ? "btn-secondary" : "btn-primary"
                  } btn-block`}
                  onClick={downloadCSV}
                >
                  Download CSV
                </button>
              </div>
            )}
          </div>
        </Card>
      ) : (
        !load && <Card>You are not authorized to view this report.</Card>
      )}
    </Dashboard>
  );
};

export default AuditReport;
